import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { isNil } from 'lodash';

import { getDisplayText } from 'utils';

import { CheckboxContent, CheckboxContainer, CheckboxLabel } from './styles';

import { ifInTestingMode } from 'utils/tests.utils';

interface Props<Value = boolean> {
  checked?: Value;
  disabled?: boolean;
  onClick?: (value: Value) => void;
  uppercase?: boolean;
  type?: string;
  label?: string;
  translationId?: string;
  size?: number;
}

const Checkbox = (props: Props) => {
  const { checked: checkedProp = false, disabled = false, onClick = null, uppercase = true, size = null } = props;

  const intl = useIntl();

  const [isChecked, setChecked] = useState(checkedProp);

  useEffect(() => {
    if (isChecked !== checkedProp) {
      setChecked(checkedProp);
    }
  }, [checkedProp]);

  const handleClick = () => {
    if (!disabled) {
      setChecked(!isChecked);

      if (onClick) {
        onClick(!isChecked);
      }
    }
  };

  let label: string | undefined;
  if (!isNil(props.translationId)) {
    label = getDisplayText(props.translationId, intl);
  }

  if (!isNil(props.label)) {
    label = props.label;
  }

  return (
    <CheckboxContainer onClick={handleClick} data-testid={ifInTestingMode('checkbox')}>
      {/* @ts-expect-error TS(2769): No overload matches this call. */}
      <CheckboxContent disabled={disabled} checked={isChecked} tabIndex="0" size={size}>
        <i className="icon-check" />
      </CheckboxContent>
      <CheckboxLabel uppercase={uppercase}>{label}</CheckboxLabel>
    </CheckboxContainer>
  );
};

export default Checkbox;
